import { IBrowserCustomerDataPlatform } from '@pathccm/common-analytics/cdp'
import { amplitude } from './amplitude'
import { segment } from './segment'
import { TrackEvent, IdentifyEvent, PageEvent } from '@pathccm/common-analytics/events'
import { RulaAmplitudeAdapter } from '@pathccm/browser-analytics/amplitude'
import { RulaSegmentAdapter, SegmentTrackEvent } from '@pathccm/browser-analytics/segment'

export type MarketingSiteSegmentTransition = 'amplitude' | 'segment' | 'both' | undefined

class ReportingAdapter implements IBrowserCustomerDataPlatform {
  private readonly marketingSiteSegmentTransition: MarketingSiteSegmentTransition

  constructor (marketingSiteSegmentTransition: MarketingSiteSegmentTransition) {
    this.marketingSiteSegmentTransition = marketingSiteSegmentTransition
  }

  track (trackEvent: SegmentTrackEvent): void {
    const { amplitude, segment } = this.currentAdapter()

    amplitude?.track(trackEvent)
    segment?.track(trackEvent)
  }

  trackLink (event: Event, href: string, trackEvent: TrackEvent): void {
    const { amplitude, segment } = this.currentAdapter()

    amplitude?.track(trackEvent)

    if (this.marketingSiteSegmentTransition === 'segment' || this.marketingSiteSegmentTransition === 'both') {
      event.preventDefault()
      // This timeout mimics the Segment behavior described in:
      // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track-link
      setTimeout(() => {
        window.location.href = href
      }, 300)
    }

    segment?.track(trackEvent)
  }

  identify (identifyEvent: IdentifyEvent): void {
    const { amplitude, segment } = this.currentAdapter()

    amplitude?.identify(identifyEvent)
    segment?.identify(identifyEvent)
  }

  page (pageEvent: PageEvent): void {
    const { amplitude, segment } = this.currentAdapter()

    amplitude?.page(pageEvent)
    segment?.page(pageEvent)
  }

  private currentAdapter (): { amplitude: RulaAmplitudeAdapter | null, segment: RulaSegmentAdapter | null } {
    if (this.marketingSiteSegmentTransition === 'amplitude') {
      return { amplitude, segment: null }
    } else if (this.marketingSiteSegmentTransition === 'segment') {
      return { amplitude: null, segment }
    } else if (this.marketingSiteSegmentTransition === 'both') {
      return { amplitude, segment }
    } else {
      return { amplitude: null, segment: null }
    }
  }
}

export default ReportingAdapter
